'use client'

import { createContext, ReactNode, useContext, useState } from 'react'

interface DemoRequestModalContextType {
  isOpen: boolean
  openModal: () => void
  closeModal: () => void
}

const DemoRequestModalContext = createContext<DemoRequestModalContextType | undefined>(undefined)

export function DemoRequestModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  return (
    <DemoRequestModalContext.Provider value={{ isOpen, openModal, closeModal }}>
      {children}
    </DemoRequestModalContext.Provider>
  )
}

export function useDemoRequestModal() {
  const context = useContext(DemoRequestModalContext)
  if (!context) {
    throw new Error('useDemoRequestModal must be used within DemoRequestModalProvider')
  }
  return context
}
